import { SELECTION_TYPES as ST } from "@meddbriefer/scenario-data/constants.js"

import CheckBoxGroup from "./CheckBoxGroup"
import RadioGroup    from "./RadioGroup"

export default function Prompt({
  id,
  label,
  abbrLabel,
  selectionType,
  answers,
  isSelected,
  getSelected,
  setSelected,
}) {
  const getLabel = () => (abbrLabel && "" !== abbrLabel ? abbrLabel : label);

  // OOM still used for dist-prompts  OOM_AND and OOM_OR are for regular prompts
  const isSelectMultiple = (selectionType) =>
    [ST.OOM, ST.OOM_AND, ST.OOM_OR].includes(selectionType);

  return (
    <>
      <i className="prompt-label">{getLabel()}</i>
      {isSelectMultiple(selectionType) ? (
        <CheckBoxGroup
          id={id}
          options={answers}
          isSelected={isSelected}
          getSelected={getSelected}
          setSelected={setSelected}
        />
      ) : (
        <RadioGroup
          id={id}
          options={answers}
          isSelected={isSelected}
          getSelected={getSelected}
          setSelected={setSelected}
        />
      )}
    </>
  );
}